import { onMounted, onUnmounted, ref } from "vue";
import { createResizeHandler, ResizeCallback } from "@/services/viewport.ts";
import * as viewportUtil from "@/util/viewportUtil.ts";

type ResizeData = {
  innerWidth: number;
  innerHeight: number;
};

type ResizeHandler = {
  onResize: (callback: ResizeCallback) => void;
  destroy: () => void;
};

export default function useWindowDimensions() {
  const innerWidth = ref(0);
  const innerHeight = ref(0);
  const isMobileViewport = ref(true);
  const isDesktopViewport = ref(false);
  const isPortraitViewport = ref(false);

  let handler: ResizeHandler;

  function updateState(width: number, height: number) {
    innerWidth.value = width;
    innerHeight.value = height;

    isMobileViewport.value = viewportUtil.isMobileAny({
      w: width,
      h: height,
    });

    isDesktopViewport.value = viewportUtil.isDesktop({
      w: width,
      h: height,
    });

    isPortraitViewport.value = viewportUtil.isPortrait({
      w: width,
      h: height,
    });
  }

  onMounted(() => {
    const storybookRoot = document.querySelector("#storybook-root");
    if (import.meta.env.STORYBOOK === "true" && storybookRoot) {
      handler = createResizeHandler(storybookRoot);
      updateState(storybookRoot.clientWidth, storybookRoot.clientHeight);
    } else {
      handler = createResizeHandler();
      updateState(window.innerWidth, window.innerHeight);
    }

    handler.onResize((data: ResizeData) => {
      updateState(data.innerWidth, data.innerHeight);
    });
  });

  onUnmounted(() => {
    handler?.destroy();
  });

  return {
    innerWidth,
    innerHeight,
    isMobileViewport,
    isDesktopViewport,
    isPortraitViewport,
  };
}
